var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464a4d",
    d: "M12 15.5A3.5 3.5 0 0 1 8.5 12 3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-3.5 3.5m7.43-2.92c.04-.34.07-.68.07-1.08s-.03-.74-.07-1.08l2.32-1.82c.21-.16.27-.46.13-.7l-2.2-3.81c-.13-.24-.42-.33-.67-.24l-2.73 1.1c-.57-.44-1.18-.8-1.86-1.07L14.05 2.1A.54.54 0 0 0 13.5 1.6h-3a.54.54 0 0 0-.54.5L9.59 4.49c-.68.27-1.3.63-1.86 1.07L5 4.46c-.25-.09-.54 0-.67.24L2.13 8.5c-.14.24-.08.54.13.7l2.32 1.82c-.04.34-.08.68-.08 1.08s.04.74.08 1.08L2.26 15.02c-.21.16-.27.46-.13.7l2.2 3.81c.13.24.42.33.67.24l2.73-1.1c.57.44 1.18.8 1.86 1.07l.37 2.39c.06.28.29.5.54.5h3a.54.54 0 0 0 .54-.5l.37-2.39c.68-.27 1.3-.63 1.86-1.07l2.73 1.1c.25.09.54 0 .67-.24l2.2-3.81c.14-.24.08-.54-.13-.7l-2.32-1.82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettings);
export default __webpack_public_path__ + "static/media/ic_settings.e97996984ee29a6bff537d713c87ad38.svg";
export { ForwardRef as ReactComponent };